import type { FC, ReactNode } from 'react'

import { LegalPage, LegalSection } from '@/components/legal/legal-page'
import { siteConfig } from '@/constants/site'

const LegalNotice: FC = (): ReactNode => {
    const { legal, contact } = siteConfig

    return (
        <LegalPage
            title='Aviso legal'
            description='Datos del titular y condiciones de uso del sitio web de Jeme.'
            intro={(
                <p>
                    En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), te informamos de los datos del titular de este sitio web y de las condiciones que regulan su uso.
                </p>
            )}
        >
            <LegalSection title='1. Datos identificativos'>
                <ul>
                    <li>Titular: {legal.owner}</li>
                    <li>NIF: {legal.taxId}</li>
                    <li>Domicilio: {legal.address}</li>
                    <li>
                        Correo electrónico: <a href={`mailto:${contact.email}`}>{contact.email}</a>
                    </li>
                </ul>
            </LegalSection>

            <LegalSection title='2. Objeto'>
                <p>
                    Este sitio web informa sobre Jeme, una aplicación móvil que conecta talleres, desguaces y particulares para solicitar, ofertar y comprar piezas de vehículos. El uso de la aplicación se rige por sus propias condiciones, que puedes consultar dentro de la app.
                </p>
            </LegalSection>

            <LegalSection title='3. Condiciones de uso'>
                <p>
                    El acceso a este sitio web es gratuito y atribuye la condición de usuario a quien lo visita. Como usuario, te comprometes a hacer un uso adecuado de sus contenidos y a no emplearlos para actividades ilícitas o contrarias a la buena fe.
                </p>
            </LegalSection>

            <LegalSection title='4. Propiedad intelectual e industrial'>
                <p>
                    Los textos, imágenes, logotipos, marcas y demás contenidos de este sitio web pertenecen a su titular o a terceros que han autorizado su uso. No está permitida su reproducción, distribución o transformación sin autorización expresa.
                </p>
            </LegalSection>

            <LegalSection title='5. Responsabilidad'>
                <p>
                    El titular no se hace responsable de los daños que puedan derivarse de interrupciones del servicio, errores técnicos o del uso indebido de este sitio web.
                </p>

                <p>
                    La identificación de piezas asistida por inteligencia artificial que ofrece la aplicación es orientativa. El usuario debe revisar siempre la información antes de enviar una solicitud o realizar un pedido.
                </p>
            </LegalSection>

            <LegalSection title='6. Enlaces a terceros'>
                <p>
                    Este sitio web incluye enlaces a sitios de terceros, como las tiendas de aplicaciones. El titular no se responsabiliza de sus contenidos ni de sus políticas.
                </p>
            </LegalSection>

            <LegalSection title='7. Legislación aplicable'>
                <p>
                    Este aviso legal se rige por la legislación española.
                </p>
            </LegalSection>
        </LegalPage>
    )
}

export default LegalNotice
